export const instructionTypeForFilter = {
  filterId: 'array',
  filterProfileName: 'string',
  filterName: 'string',
};
